// extracted by mini-css-extract-plugin
export default {"AppLayout":"AppLayout_AppLayout__5oBEO"};